import './PasswordField.css';
import { useState } from 'react';

// One password box on the profile form. It lines up with the profile's other fields (.user-field and
// .user-field-edit from User.css) and carries the show/hide control the log-in and sign-up forms use:
// it appears once something has been typed, and each box keeps its own, so revealing one password
// does not reveal the other.
//
// Nothing here is required. Leaving both boxes empty on the profile means "keep the password I have".

export default function PasswordField({ label, value, onChange, autoComplete, className = '' }) {

    const [shown, setShown] = useState(false);

    return (
        <label className={`user-field ${className}`.trim()}>
            <div className='user-field-title'>{label}</div>
            <div className='user-field-content password-field'>
                <input className='user-field-edit password-field-input'
                       type={shown ? 'text' : 'password'}
                       value={value}
                       onChange={(e) => onChange(e.target.value)}
                       autoComplete={autoComplete} />
                <button className='password-field-show' type='button'
                        aria-label={`${shown ? 'Hide' : 'Show'} ${label.toLowerCase()}`}
                        onClick={() => setShown((was) => !was)}>
                    {value.length > 0 ?
                        <i className={shown ? 'fa-solid fa-eye' : 'fa-solid fa-eye-slash'}></i> :
                        <></>
                    }
                </button>
            </div>
        </label>
    );
}
